export default {
  title: 'שמרו על קשר',
  form: {
    name: 'שם מלא',
    phone: 'טלפון',
    email: 'דואר אלקטרוני',
    help: 'איך אנחנו יכולים לעזור?',
    agree: 'אני מאשר/ת את הוספת הפרטים שלי לרשימת התפוצה לטובת קבלת מידע ועדכונים.',
    send: 'שליחה',
    success: 'ההודעה נשלחה בהצלחה!',
    error: 'ההודעה לא נשלחה, נסה שנית.',
  },
  details: {
    address: 'שנקר 3 הרצליה פיתוח',
    phone: 'טלפון: 050-7683557',
    email: 'service@polaris-fin.co.il',
  },
};
